import React from "react";
import CountUp from "react-countup";
import { Translation } from "../../Translation";
import { inject, observer } from "mobx-react";

@inject("AppStore")
@observer
class MobileTitle extends React.Component {
  store = this.props.AppStore;

  render() {
    const { data, summary, lastPrice, location } = this.store;

    return (
      <div className="mobile-title">
        <span dangerouslySetInnerHTML={{ __html: data.name }}></span>
        <div className="pricing">
          <span style={{ fontSize: 12 }}>
            <Translation t="PRICE" lang={this.store.page.lang} />
          </span>
          <br />
          <CountUp
            className="price-text orbitron"
            separator=","
            decimals={2}
            decimal="."
            prefix={location.symbol}
            duration={1}
            start={lastPrice}
            end={summary.purchase_price}
            preserveValue={true}
            redraw={true}
            key={summary.purchase_price} // Force re-render when price changes
          />
        </div>
      </div>
    );
  }
}

export default MobileTitle;
